import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';
import {redirect} from '../shared/constants';
import {isEmpty} from 'sdv-common';
import {UserService} from '../service/user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public apiService: ApiService,
              public userService: UserService) {
  }

  ngOnInit() {
    if (this.apiService.isAnonymous()) {
      const token = this.apiService.getParam('token');
      if (!isEmpty(token)) {
        this.apiService.get('contacts/confirm', {
          hash: token
        })
          .subscribe(res => {
            redirect('/sign-in?' + new URLSearchParams(res || {}).toString());
          }, err => {
            redirect('/500?' + new URLSearchParams(err || {}).toString());
          });
      }
    }
  }
}
